import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { NomenclatureGroup } from '@/types';
import { useDeleteNomenclatureGroupMutation } from '@/services';

export interface DeleteNomenclatureGroupProps extends DialogProps {
  nomenclatureGroup: NomenclatureGroup;
  onClose(): void;
}

const DeleteNomenclatureGroup: React.FC<DeleteNomenclatureGroupProps> = ({ nomenclatureGroup, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteNomenclatureGroup, deleteNomenclatureGroupResponse] = useDeleteNomenclatureGroupMutation();

  async function handleDeleteNomenclatureGroup() {
    try {
      await deleteNomenclatureGroup(nomenclatureGroup).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{nomenclatureGroup?.name}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{nomenclatureGroup?.name}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          color="secondary"
          variant="outlined"
          disabled={deleteNomenclatureGroupResponse.isLoading}
          onClick={onClose}
        >
          Закрыть
        </Button>

        <Button
          variant="contained"
          disabled={deleteNomenclatureGroupResponse.isLoading}
          onClick={handleDeleteNomenclatureGroup}
        >
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteNomenclatureGroup;
